import { IdentityProviderSettingsListItem} from '../../../integrated-client/models/';

export class ResultsData {

  items: Array<IdentityProviderSettingsListItem>
  showMore: boolean

  constructor() {
    this.items = [];
    this.showMore = false;
  }

}
